import React, { useContext } from "react";
import Button from "@src/components/Button";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import { mediaQueriesMax } from "@src/styles/theme";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";

const Meta = styled("div")`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;

  margin: 26px 0 0 41px;

  ${mediaQueriesMax.lesson} {
    flex-direction: column;
    margin: 20px 38px 0 20px;
  }
`;

const MetaTeaser = styled("div")`
  width: 321px;

  font-size: 16px;
  line-height: 20px;
  color: #2c2f42;

  ${mediaQueriesMax.lesson} {
    width: 100%;
  }

  p {
    margin: 0 0 20px 0;
  }
`;

const MetaGuideline = styled("div")`
  margin: 0 0 0 50px;

  ${mediaQueriesMax.lesson} {
    margin: 30px 0 0 0;
  }

  ul {
    list-style: none;
    padding: 4px 0 4px 34px;
    margin: 0;

    li {
      position: relative;

      display: block;

      margin: 31px 0 0 0;

      font-size: 16px;
      font-weight: 600;
      color: #2c2f42;
      line-height: 1;

      &:first-of-type {
        margin: 0;
      }

      .guide-icon {
        position: absolute;
        left: -34px;
        top: -4px;

        width: 24px;
        height: 24px;
        background-repeat: no-repeat;
        background-position: center;
        border: solid 1px rgba(0, 0, 0, 0.24);
        border-radius: 24px;

        &.icon-play {
          background-size: 15px 15px;
          background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMyZjQyIiBmaWxsLW9wYWNpdHk9IjAuMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGQ9Ik04IDV2MTRsMTEtN3oiLz4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==);
        }

        &.icon-message {
          background-size: 12px 12px;
          background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMyZjQyIiBmaWxsLW9wYWNpdHk9IjAuMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGQ9Ik0yMCAySDRjLTEuMSAwLTEuOTkuOS0xLjk5IDJMMiAyMmw0LTRoMTRjMS4xIDAgMi0uOSAyLTJWNGMwLTEuMS0uOS0yLTItMnptLTIgMTJINnYtMmgxMnYyem0wLTNINlY5aDEydjJ6bTAtM0g2VjZoMTJ2MnoiLz4gICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==);
        }

        &.icon-home {
          background-size: 15px 14px;
          background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMyZjQyIiBmaWxsLW9wYWNpdHk9IjAuMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGQ9Ik0xMCAyMHYtNmg0djZoNXYtOGgzTDEyIDMgMiAxMmgzdjh6Ii8+ICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=);
        }

        &.icon-activity {
          background-size: 12px 12px;
          background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMyZjQyIiBmaWxsLW9wYWNpdHk9IjAuMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+ICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4gICAgPHBhdGggZD0iTTIwIDEyYzAtMS4xLjktMiAyLTJWNmMwLTEuMS0uOS0yLTItMkg0Yy0xLjEgMC0xLjk5LjktMS45OSAydjRjMS4xIDAgMS45OS45IDEuOTkgMnMtLjg5IDItMiAydjRjMCAxLjEuOSAyIDIgMmgxNmMxLjEgMCAyLS45IDItMnYtNGMtMS4xIDAtMi0uOS0yLTJ6bS00LjQyIDQuOEwxMiAxNC41bC0zLjU4IDIuMyAxLjA4LTQuMTItMy4yOS0yLjY5IDQuMjQtLjI1TDEyIDUuOGwxLjU0IDMuOTUgNC4yNC4yNS0zLjI5IDIuNjkgMS4wOSA0LjExeiIvPjwvc3ZnPg==);
        }
      }

      .guide-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        ${mediaQueriesMax.lesson} {
          width: 326px;
        }

        > a {
          color: #2c2f42;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    li + li:after {
      content: "";

      position: absolute;
      left: -22px;
      top: -28px;

      height: 25px;
      border-left: 1px solid rgba(0, 0, 0, 0.24);
    }
  }
`;

const LessonMetaBottom = (props) => {
  const guideline = props.steps.map((e, i) => {
    return (
      <GuideLineSymbol
        key={i}
        urlSlug={props.slug}
        title={e.title}
        canWatch={true}
        slide={i}
        numSteps={Object.keys(props.steps).length}
      />
    );
  });
  let content = props.teaser;
  if (content) {
    content = content.replace(/\\n/g, "");
  }
  return (
    <Meta>
      <div>
        <MetaTeaser
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      </div>
      <MetaGuideline>
        <ul>{guideline}</ul>
      </MetaGuideline>
    </Meta>
  );
};

const GuideLineSymbol = ({ canWatch, urlSlug, slide, title, numSteps }) => {
  const modals = useContext(ModalContext);

  const symbols = {
    watch: "icon-play",
    discuss: "icon-message",
    share: "icon-home",
    activity: "icon-activity",
  };

  const lowerCaseTitle = title.toLowerCase();
  let className = "guide-icon ";

  if (lowerCaseTitle.includes("watch")) {
    className += symbols.watch;
  } else if (lowerCaseTitle.includes("discuss")) {
    className += symbols.discuss;
  } else if (lowerCaseTitle.includes("share")) {
    className += symbols.share;
    title = "Share to Class Story";
  } else {
    className += symbols.activity;
  }

  return (
    <li>
      {numSteps > 1 && <div className={className} />}
      <div className="guide-text">
        {canWatch ? (
          <Link to={`/f/${urlSlug}/${slide}`}>{numSteps > 1 ? title : <Button big>{title}</Button>}</Link>
        ) : (
          <div>
            {numSteps > 1 ? (
              <a onClick={() => modals.showModal(ModalType.TeacherSignup)}>{title}</a>
            ) : (
              <Button onClick={() => modals.showModal(ModalType.TeacherSignup)}>{title}</Button>
            )}
          </div>
        )}
      </div>
    </li>
  );
};

export default LessonMetaBottom;
